import { render } from "./AppTableCell.vue?vue&type=template&id=598b84b2&ts=true"
import script from "./AppTableCell.vue?vue&type=script&lang=ts"
export * from "./AppTableCell.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/wVusKqw4/0/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__